export default (axios) => ({
	getCbsPoaData(queryString) {
		return axios.get("/cbs_poas", {
			params: queryString
		})
	},
})